<template>
  <div class="space-y-2">
    <p>
      We use a single, strictly necessary cookie to store a JSON Web Token (JWT) that:
    </p>
    <ul class="list-disc list-inside space-y-1">
      <li>Authenticates your session after login</li>
      <li>Grants secure access to member-only or restricted areas</li>
      <li>Ensures continuity while navigating the site</li>
      <li>Automatically expires upon logout or after a set period</li>
    </ul>
    <p>
      We do not use cookies for analytics, marketing, or advertising.
    </p>
    <p>
      Because this cookie is essential for the site to function, you cannot disable it without losing access to your account.
    </p>
  </div>
</template>